import {createSlice} from '@reduxjs/toolkit';

import {customDealBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  error: '',
  currentDealId: null,
  inProgressDeals: [],
  doneDeals: {},
  categories: [],
  categoriesLoading: false,
  subCategories: [],
  subCategoriesLoading: false,
  products: {},
  productsLoading: false,
  dealProducts: {},
  dealProductsLoading: false,
  idToDiscount: {},
  dealCategories: [],
  dealSummary: [],
  searchedProducts: []
};

export const customDealSlicer = createSlice({
  name: 'customDeal',
  initialState,
  reducers: {
    resetDoneDeals(state: any) {
      state.doneDeals = initialState.doneDeals;
    },
    resetProducts(state: any) {
      state.products = initialState.products;
    },
    resetDealProducts(state: any) {
      state.dealProducts = initialState.dealProducts;
    },
    resetCategories(state: any) {
      state.categories = initialState.categories;
    },
    resetSubCategories(state: any) {
      state.subCategories = initialState.subCategories;
    },
    addSearchedProduct(state: any, action: any) {
      const product = action.payload;
      if (!state.searchedProducts.some((p) => p.id === product.id)) {
        state.searchedProducts.push(product);
      }
    },
    addProductToTop(state: any, action: any) {
      const product = action.payload;
      if (!state.products?.items) {
        state.products = {
          items: [],
          total_items: 0,
          page: 1,
          size: 10,
          total_pages: 0
        };
      }
      // Remove product if it already exists
      const existingIndex = state.products.items.findIndex((item) => item.id === product.id);
      if (existingIndex !== -1) {
        state.products.items.splice(existingIndex, 1);
      }
      // Add product to the top
      state.products.items = [product, ...state.products.items];
      // Update total_items if product was new
      if (existingIndex === -1) {
        state.products.total_items = (state.products.total_items || 0) + 1;
      }
    }
  },
  extraReducers: customDealBuilder
});

export const {
  resetDoneDeals,
  resetProducts,
  resetDealProducts,
  resetCategories,
  resetSubCategories,
  addSearchedProduct,
  addProductToTop
} = customDealSlicer.actions;
export default customDealSlicer.reducer;
